<router-outlet></router-outlet>
<div *ngIf="developmentMode" class="feedback-icon-wrapper" data-html2canvas-ignore>
    <div>
        <div (click)="downloadScreenShot(true)"><abbr title="give positive feedback">😊</abbr></div>
        <div (click)="downloadScreenShot(false)"><abbr title="give negative feedback">🙁</abbr></div>
    </div>
    <div style="writing-mode: vertical-lr; font-size: small;">feedback</div>
</div>